import NFA from 'shared/helpers/analytics/NFAnalytics';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { getPageInfoFromURL } from 'shared/helpers/analytics/helpers';

export const APP_MIGRATION_EVENTS = {
  CLICK: 'app_migration_click',
} as const;

export type AppMigrationSurface = 'banner' | 'floater';

export type AppMigrationAnalyticsPage = string;

export type AppMigrationInteractionLocation = string;

export const getAppMigrationAnalyticsPage = (): AppMigrationAnalyticsPage =>
  NFA.pageProperties?.pagetype ||
  (typeof window !== 'undefined'
    ? getPageInfoFromURL(window.location.href)?.pagetype
    : '') ||
  'otherPage';

export const buildAppMigrationInteractionLocation = (
  page: AppMigrationAnalyticsPage,
  surface: AppMigrationSurface
): AppMigrationInteractionLocation => `${page}:${surface}`;

/**
 * Fires `app_migration_click` on download CTA (bottom sheet or top banner).
 * Superproperties are attached via NFA.track global merge.
 */
export const trackAppMigrationClick = ({
  interactionLocation,
}: {
  interactionLocation: AppMigrationInteractionLocation;
}): void => {
  try {
    NFA.track({
      type: TRACK_TYPE.EVENT,
      event: APP_MIGRATION_EVENTS.CLICK,
      data: {
        interaction_location: interactionLocation,
      },
    });
  } catch {
    // non-fatal
  }
};
